<template>
    <div class="liai-1">
        <div class="block">
            <el-timeline>
                <el-timeline-item
                    placement="top"
                    v-for="(activity, index) in activities"
                    :key="index"
                    type="primary"
                    :timestamp="activity.timestamp"
                    :class="{ title1: index % 2 == 0, title2: index % 2 != 0 }"
                >
                    <el-card
                        :class="{
                            change1: index % 2 == 0,
                            change2: index % 2 != 0,
                        }"
                        class="card-color"
                    >
                        <div class="list-1">{{ activity.content }}</div>
                        <div class="list-2">{{ activity.content1 }}</div>
                        <div class="list-3">电话号码：{{ activity.phone }}</div>
                    </el-card>
                </el-timeline-item>
            </el-timeline>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            activities: [
                //   {
                // 	content: '呼出 > 回访',
                // 	content1: '二是高分红该如何是分手歌',
                // 	timestamp: '2018-04-12 20:46',
                // 	phone: '12356789098'
                // }, {
                // 	content: '呼出 > 回访',
                // 	content1: '二是高分红该如何是分手歌',
                // 	timestamp: '2018-04-03 20:46',
                // 	phone: '12356789098'
                // }, {
                // 	content: '呼出 > 回访',
                // 	content1: '二是高分红该如何是分手歌',
                // 	timestamp: '2018-04-03 20:46',
                // 	phone: '12356789098'
                // }, {
                // 	content: '呼出 > 回访',
                // 	content1: '二是高分红该如何是分手歌',
                // 	timestamp: '2018-04-03 20:46',
                // 	phone: '12356789098'
                // }
            ],
        }
    },
    mounted() {},
    methods: {},
}
</script>

<style lang="less" scoped>
.liai-1 {
    width: 98%;
    margin-left: 2%;
}

.card-color {
    color: #ffffff;
}

.change1 {
    background-color: #6cbfee;
}

.change2 {
    background-color: #3594cb;
}

.list-1 {
    height: 26px;
    border-bottom: 1px solid #ffffff;
}

.list-2 {
    height: 36px;
    line-height: 36px;
    border-bottom: 1px solid #ffffff;
}

.list-3 {
    margin-top: 10px;
}

.title1 {
    /deep/.el-timeline-item__timestamp {
        color: #6cbfee;
        font-size: 16px;
        font-weight: bold;
    }
}

.title2 {
    /deep/.el-timeline-item__timestamp {
        color: #3594cb;
        font-size: 16px;
        font-weight: bold;
    }
}
</style>
